module.exports = __webpack_public_path__ + "static/img/dp-logo.d19133b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/dp-logo.jpg
// module id = 3bHG
// module chunks = 0